import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة وقت تشغيل البطارية - حساب عدد ساعات عمل البطارية";
const DESCRIPTION =
  "احسب وقت تشغيل بطارية جهاز معين بناءً على سعة البطارية وسحب التيار للجهاز. تساعدك هذه الحاسبة في معرفة مدة التشغيل التي يمكنك الحصول عليها من بطارية معينة.";
const KEYWORDS = "حاسبة, بطارية, وقت تشغيل, سعة, تيار, جهاز";
const OG_URL =
  "https://do-calculate.com/calculator/ar/battery-life-calculator/";
function BatteryLifeCalculator() {
  const [batteryCapacity, setBatteryCapacity] = useState("0");
  const [deviceCurrentDraw, setDeviceCurrentDraw] = useState("0");
  const [operatingTime, setOperatingTime] = useState(null);
  const [error, setError] = useState("");
  const calculateOperatingTime = () => {
    try {
      if (batteryCapacity === "0" && deviceCurrentDraw === "0") {
        setError("الرجاء إدخال قيم من أجل حساب وقت التشغيل");
        return;
      }
      const time = batteryCapacity / deviceCurrentDraw;
      setOperatingTime(time);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  توفر هذه الحاسبة وسيلة بسيطة لحساب وقت تشغيل البطارية عندما
                  تكون متصلة بجهاز معين. يعتمد وقت التشغيل على سعة البطارية
                  (مقاسة بالأمبير ساعة) وسحب التيار من الجهاز (مقاسًا بالأمبير).
                  من خلال إدخال هذه القيم، يمكنك بسهولة معرفة عدد الساعات التي
                  ستعمل فيها البطارية قبل أن تحتاج إلى إعادة شحنها. يعتبر هذا
                  مفيدًا جدًا عند التخطيط لاستخدام الأجهزة المحمولة أو تجهيزات
                  الطاقة الاحتياطية.
                </p>
                <p>
                  على سبيل المثال، إذا كنت تمتلك بطارية بسعة 150 أمبير ساعة
                  وتستخدمها لتشغيل جهاز يسحب 30 أمبير من التيار، يمكنك استخدام
                  هذه الحاسبة لحساب مدة التشغيل المتوقعة للبطارية. هذه المعلومات
                  ضرورية في مواقف متعددة، مثل عند التخييم أو في حالات الطوارئ
                  حيث تكون الطاقة المتاحة محدودة وتحتاج إلى إدارة استخدامها
                  بحكمة.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="battery-capacity">
                      سعة البطارية (أمبير ساعة):
                    </label>
                    <input
                      id="battery-capacity"
                      type="number"
                      value={batteryCapacity}
                      onChange={(e) => setBatteryCapacity(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="device-draw">
                      سحب تيار الجهاز (أمبير):
                    </label>
                    <input
                      id="device-draw"
                      type="number"
                      value={deviceCurrentDraw}
                      onChange={(e) => setDeviceCurrentDraw(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text">A</span>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateOperatingTime}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  operatingTime !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>
                        وقت التشغيل المتوقع: {operatingTime.toFixed(2)} ساعة
                      </p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية حساب وقت تشغيل البطارية</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 1: تحديد سعة البطارية
                    </h2>
                  </u>
                  <p>
                    في البداية، يجب عليك معرفة سعة البطارية التي تستخدمها،
                    والمقاسة بوحدة الأمبير ساعة (Ah). سعة البطارية تمثل كمية
                    الشحنة الكهربائية التي يمكن للبطارية تخزينها. من المهم أن
                    تعرف السعة الدقيقة للبطارية لأن هذا سيؤثر مباشرة على مدة
                    تشغيل الجهاز المتصل بها. يمكن العثور على سعة البطارية عادة
                    مكتوبة على ملصق البطارية نفسها.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 2: معرفة سحب تيار الجهاز
                    </h2>
                  </u>
                  <p>
                    بعد تحديد سعة البطارية، الخطوة التالية هي معرفة سحب التيار
                    الخاص بالجهاز الذي سيتم تشغيله بواسطة البطارية. سحب التيار
                    يقاس بالأمبير (A) ويمثل مقدار التيار الكهربائي الذي يحتاجه
                    الجهاز للعمل. يمكن العثور على سحب التيار في دليل المستخدم
                    للجهاز أو على الملصق الموجود على الجهاز نفسه. هذه المعلومة
                    ضرورية لأن سحب التيار يؤثر بشكل مباشر على سرعة استهلاك
                    البطارية.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 3: حساب وقت التشغيل
                    </h2>
                  </u>
                  <p>
                    الآن وبعد أن عرفت سعة البطارية وسحب التيار، يمكنك حساب وقت
                    التشغيل المتوقع. لحساب وقت التشغيل، قسّم سعة البطارية
                    (بالأمبير ساعة) على سحب التيار الخاص بالجهاز (بالأمبير).
                    سيعطيك هذا الناتج عدد الساعات التي ستعمل فيها البطارية قبل
                    أن تحتاج إلى إعادة شحنها. على سبيل المثال، إذا كانت سعة
                    البطارية 150 أمبير ساعة والجهاز يسحب 30 أمبير، فإن وقت
                    التشغيل سيكون 5 ساعات.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: 150 أمبير ساعة / 30 أمبير = 5 ساعات.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 4: التأكد من الحسابات وتوقعات الأداء
                    </h2>
                  </u>
                  <p>
                    بعد إجراء الحسابات، من المهم التأكد من أن القيم التي
                    استخدمتها صحيحة وأن الحسابات دقيقة. قد تكون هناك عوامل
                    إضافية تؤثر على أداء البطارية مثل درجة الحرارة أو كفاءة
                    الجهاز. لذلك، يمكن أن تكون النتائج تقريبة وليست دقيقة
                    تمامًا. تأكد من مراقبة أداء البطارية في الاستخدام الفعلي
                    للتأكد من أن الحسابات تتماشى مع الواقع.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    تذكر: الأداء الفعلي قد يختلف بناءً على عدة عوامل مثل كفاءة
                    الجهاز ودرجة الحرارة.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BatteryLifeCalculator;
